export default __webpack_public_path__ + "static/media/2.04e8c402.png";